import classNames from 'classnames';
import React, { PureComponent } from 'react';

import Longform from '@components/Longform';
import RatingGrid from '@components/RatingGrid';
import SingleDropdown from '@components/SingleDropdown';
import TextArea from '@components/TextArea';
import TextField from '@components/TextField';

import styles from './subComponentCell.scss';

interface SubComponentCellProps {
  id: string;
  questionId: number;
  component: {
    blockType?: string;
  };
  answerQuestion: (...args: unknown[]) => unknown;
  columnCaption?: string;
  isMobileMedia?: boolean;
}

class SubComponentCell extends PureComponent<SubComponentCellProps> {
  getSubComponent() {
    const { component, isMobileMedia } = this.props;
    const { caption, blockType, blockId, ...componentData } = component;

    switch (blockType) {
      case 'dropdown':
        return (
          <SingleDropdown
            alt={component.alt}
            formkey={component.formkey}
            id={blockId}
            isMultiValued={component.multivalued}
            isSubComponent
          />
        );
      case 'grid':
        return isMobileMedia && !componentData.isNumeric ? (
          <Longform id={blockId} isSubComponent />
        ) : (
          <RatingGrid id={blockId} isSubComponent />
        );
      case 'longform':
        return <Longform id={blockId} isSubComponent isHorizontal={!isMobileMedia} />;
      case 'choose':
        return <Longform id={blockId} isSubComponent isHorizontal={!isMobileMedia} />;
      case 'textfield':
        return <TextField id={blockId} {...componentData} isSubComponent />;
      case 'textarea':
        return (
          <TextArea id={blockId} {...componentData} isMobileMedia={isMobileMedia} isInMatrix />
        );
      default:
        return null;
    }
  }

  render() {
    const { component, isMobileMedia, columnCaption, rowCaption, columnIndex, questionCaption } =
      this.props;
    const subComponentStyles = styles[component.blockType] || '';
    const componentStyles = classNames(subComponentStyles, {
      [styles.mobileSubComponentCell]: isMobileMedia
    });

    return (
      <div className={componentStyles} data-test-id={`cell_${component.blockId}`}>
        <fieldset role={'group'} aria-label={`${questionCaption} ${rowCaption} ${columnCaption}`}>
          {isMobileMedia && <div className={styles.mobileColumnCaption}>{columnCaption}</div>}
          {this.getSubComponent()}
        </fieldset>
      </div>
    );
  }
}

SubComponentCell.defaultProps = {
  columnCaption: '',
  isMobileMedia: false
};

export default SubComponentCell;
